module.exports = __webpack_public_path__ + "img/draf.4121f139.svg";